const SPLIT_IO_LOCAL_STORAGE_KEY = 'split_io_uuid'

const getSplitIOKey = () => {
  const splitIOKey = localStorage.getItem(SPLIT_IO_LOCAL_STORAGE_KEY)

  if (splitIOKey) {
    return splitIOKey
  }

  const uuid = crypto.randomUUID()
  localStorage.setItem(SPLIT_IO_LOCAL_STORAGE_KEY, uuid)

  return uuid
}

export const getSplitIOConfig = () => ({
  core: {
    authorizationKey: process.env.SPLIT_IO_API_KEY,
    key: getSplitIOKey(),
  },
})
